<template>
  <!-- !!! -->
  <!-- !!! -->
  <!-- !!! -->
  <!-- 若有改动，请仔细观察后端返回格式再来修改 -->
  <div>
    <div style="background-color: #ffffff;width: 100%;height: 70vh">
      <date-select @StatisticType="GetStatisticType" :Multiple="true"></date-select>
      <v-chart :options="option" :autoresize="true" v-show="CharShow"/>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/dataZoom";
import DateSelect from "./components/DateSelect";
import { listOnline } from '@/api/onlinerate'
import { tooltipFormate,
         axisFormate, 
         otherStyle, 
         GetonlinerateYear,
         GetonlinerateDay,
         GetonlinerateTime,
         GetonlinerateTimeMinute 
} from './components/GetValue'
import { mapGetters } from 'vuex'
export default {
  name: 'Onlinerate',
  data() {
    return {
      CharShow:false,
      option: {}
    };
  },
  mounted(){
    //进入页面获取在线率统计
    listOnline({year: new Date().getFullYear(),gid:this.defaultGroupId}).then((res)=>{
      if(res.data.data){
        const Data=GetonlinerateYear(new Date().getFullYear(),res.data.data)
        Data.Time.length>0?this.CharShow=true:this.CharShow=false
        this.setOptions(1, Data.Time, Data.data)
      }
    })
  },
  methods:{
    // 设置图形样式和数据，不同统计类型有不同的样式
    setOptions(statistisType, xAxisData, seriesData) {
      this.option = {
        backgroundColor: "#fff",
        color: ["#37A2DA", "#32C5E9"],
        tooltip: {
          trigger: "axis",
          axisPointer: otherStyle.axisPointer,
          // 鼠标悬浮时显示数据的样式
          formatter: function (params) {
            let name = tooltipFormate(params, statistisType)
            return `${name}<br />
                    <span style="width: 10px;height: 10px;background-color: #37A2DA;border-radius: 50%;vertical-align: middle;display: inline-block;"></span>
                    ${params[0].seriesName} : ${params[0].value}%`
          },
        },
        // 下方滑动条
        dataZoom: otherStyle.dataZoom,
        legend: {
          data: [
            {
              name: this.$t('lang.ReportManagement.Rates'),
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            }
          ],
          top: "10%",
          textStyle: {
            color: "#fff"
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
          axisLabel: {
            interval: 0,
            formatter: function (value, index) {
              let val = axisFormate(value, statistisType)
              return val         
            },
          },
          // 刻度样式
          axisTick:{     
            inside: true, // 设置刻度朝内
          },
        },
        yAxis: {
          type: "value",
          name: `${this.$t('lang.ReportManagement.Units')}(%)`
        },
        grid: otherStyle.grid,
        series: [
          {
            name: this.$t('lang.ReportManagement.Rates'),
            type: "line",
            symbol: 'none',
            data: seriesData
          }
        ]
      }
    },
    GetStatisticType(data,DayClass){
      //统计类型
      let Value=data.DateClassValue
      //删除统计类型
      delete data.DateClassValue
      //获取筛选后的数据与时间
      let Data;
      listOnline(data).then((res)=>{
        switch (Value) {
        case 4:
          Data=GetonlinerateTimeMinute(data.clock,res.data.data)
          //如果筛选出来的数据没有时间隐藏图表
          Data.Time.length>0?this.CharShow=true:this.CharShow=false
          this.setOptions(4, Data.Time, Data.data)
          break;
        case 3:
          Data = GetonlinerateTime(res.data.data)
          //如果筛选出来的数据没有时间隐藏图表
          Data.Time.length > 0 ? this.CharShow = true : this.CharShow = false
          this.setOptions(3, Data.Time, Data.data)
          break;
        case 2:
          Data = GetonlinerateDay(data.month, DayClass, res.data.data)
          //如果筛选出来的数据没有时间隐藏图表 
          Data.Time.length > 0 ? this.CharShow = true : this.CharShow = false
          this.setOptions(2, Data.Time, Data.data)
          break;
        case 1:
          Data = GetonlinerateYear(data.year, res.data.data)
          //如果筛选出来的数据没有时间隐藏图表
          Data.Time.length > 0 ? this.CharShow = true : this.CharShow = false
          this.setOptions(1, Data.Time, Data.data)
          break;
        default:
          break;
      }
      if(Object.keys(Data.data).length<1){
          this.$confirm(this.$t('lang.ReportManagement.datatype'), this.$t('lang.ReportManagement.setPrompt'), {
          confirmButtonText: this.$t('lang.ReportManagement.Determine'),
          showCancelButton:false,
          type: 'warning',
          center: true
        })
      }
      })
    }
  },
  components: {
    DateSelect
  },
  computed:{
    ...mapGetters(['defaultGroupId']),
  }
};
</script>

<style scoped>
.inputlist {
  width: 1.8rem;
  margin: 0.1rem;
}
.echarts {
  width: 100%;
  height: 90%;
}
</style>
